import { createListenerMiddleware } from "@reduxjs/toolkit";
import { fetchVehicleTripSegments, fetchGeocodedTripStopPositionAddresses } from "../store/monitorViewSlice";

export const tripListener = createListenerMiddleware();

tripListener.startListening({
    actionCreator: fetchVehicleTripSegments.fulfilled,
    effect: async(action, { dispatch }) => {
        const stopped = action.payload
            .map((seg) => ({ ...seg }))
            .filter(seg => seg.state === "Stopped");

        if (stopped.length > 0) {
            await dispatch(fetchGeocodedTripStopPositionAddresses(stopped.map(seg => ({
                id: seg.startTime, // or generated ID
                lat: seg.positions[0].latitude,
                lon: seg.positions[0].longitude
            })))).catch(err => console.error(err));
        }
    }
});